import { guestRoutes } from './authGuard';

export const authorityGuard = (to, userStore) => {
  const { hasAuthority, isAuthenticated, isMobileVerified } = userStore;

  if (isAuthenticated.value && to.meta.authority && !hasAuthority(to.meta.authority)) {
    return { name: 'unauthorized' };
  }

  if (
    isAuthenticated.value &&
    guestRoutes.includes(to.name) &&
    hasAuthority(to.meta.authority) &&
    isMobileVerified.value
  ) {
    return { name: 'merchants' };
  }
};
